import React, {Component, useEffect, useImperativeHandle, useState} from 'react'
import {Modal, Button, Table, List, Input} from 'antd'
// import Editor from "../../../utils/brace";
import ApiManagementAPI from '../../../apis/apiManagementAPI'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import {toJS} from 'mobx'

const TableStructure = props => {
  const [initTreeData, setInitTreeData] = useState([])
  const [treeData, setTreeData] = useState([])
  const [isTreeloading, setIsTreeloading] = useState(false)
  const [tableData, setTableData] = useState([])
  const [currentIndex, setCurrentIndex] = useState(null)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const {dataIngestion, ingestionId, t, canSelect, apiManagementStore} = props

  useEffect(() => {
    getTreeList()
  }, [])

  const getTreeList = () => {
    setIsTreeloading(true)
    let params = {
      ingestionId: ingestionId,
      dataIngestion: dataIngestion
    }
    ApiManagementAPI.getViewList(params).then(res => {
      let treeData = res.data.data.tableName
      setInitTreeData(treeData)
      setTreeData(treeData)
      setIsTreeloading(false)
    })
  }

  const searchValue = (e) => {
    console.log(4545, e.target.value)
    if (e.target.value) {
      let arr = search(e.target.value, initTreeData)
      setTreeData(arr)
    } else {
      setTreeData(initTreeData)
    }
  }

  const search = (value, list) => {
    if (value) {
      let arr = []
      list.forEach(el => {
        if (el.indexOf(value) >= 0) {
          arr.push(el)
        }
      })
      return arr
    }
  }

  const onTreeClick = (item, index) => {
    let params = {
      ingestionId: ingestionId,
      dataIngestion: dataIngestion,
      tableName: item
    }
    apiManagementStore.saveTableName(item)
    ApiManagementAPI.getViewList(params).then(res => {
      setTableData(res.data.data.tableInfoDtos)
    })
    setCurrentIndex(index)
  }

  const handleCancel = () => {
    props.closeTableStructure()
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys)
    setSelectedRows(selectedRows)
  }

  const rowSelection = canSelect ? {
    selectedRowKeys,
    onChange: onSelectChange,
  } : null

  const onSave = () => {
    apiManagementStore.saveSelectedRows(selectedRows)
    props.generateSql()
    handleCancel()
  }

  return (
    <>
      <Modal
        visible={true}
        title={t(`apiManagement.tableStructure`)}
        width={1200}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          // canSelect ? <Button type="primary" key="save" onClick={onSave}>{t(`general.save`)}</Button> : null,
          dataIngestion === 'DATATARGET' && canSelect ? <Button type="primary" onClick={onSave}>{t(`apiManagement.generateSql`)}</Button> : null
        ]}
      >
        <div style={{display: 'flex', justifyContent: 'space-around'}}>
          <div>
            <Input placeholder={t(`general.search`)} onChange={searchValue} allowClear/>
            <List
              style={{height: '460px', overflowY: 'scroll'}}
              loading={isTreeloading}
              dataSource={treeData}
              renderItem={(item, index) => (
                <List.Item className={currentIndex === index ? 'isActive isHover' : 'isHover'}
                           onClick={() => { onTreeClick(item, index) }}>{item}</List.Item>
              )}
            />
          </div>
          <Table rowSelection={rowSelection} dataSource={tableData} pagination={false} style={{width: '600px'}} rowKey="name" scroll={{y: 460}}>
            <Table.Column title={t(`apiManagement.name`)} dataIndex="name" key="name"/>
            <Table.Column title={t(`apiManagement.type`)} dataIndex="type" key="type"/>
            <Table.Column title={t(`apiManagement.key`)} dataIndex="majorKey" key="majorKey"/>
            <Table.Column title={t(`apiManagement.remark`)} dataIndex="remark" key="remark"/>
          </Table>
        </div>
      </Modal>
    </>
  )
}

export default withTranslation()(inject('apiManagementStore')(observer(TableStructure)))
